import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-[#F5F2EA] border-2 border-[#1C1C1C] hard-shadow hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all duration-200"
    >
      <div className="relative aspect-square overflow-hidden bg-[#EDE8DD] border-b-2 border-[#1C1C1C]">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 bg-[#1C1C1C] text-[#FDFBF7] text-[10px] font-bold uppercase tracking-widest px-2 py-1">
          {product.category}
        </span>
        {product.featured && (
          <span className="absolute top-3 right-3 bg-[#D35400] text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1">
            Featured
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-display text-2xl leading-none tracking-wide">{product.name}</h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs uppercase tracking-widest text-[#4A4A4A]">{product.collection}</span>
          <span className="font-bold text-lg text-[#C0392B]">${product.price.toFixed(2)}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
